<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { fly } from "svelte/transition"
    import SubField from "./subField.svelte"
    import PersonCard from "./PersonCard.svelte"
    import PersonDetails from "./personDetails.svelte"
    export let subPoint: SubField

    const dispatch = createEventDispatcher()
    let card = null
    export let i: number
    export let rowI: number
</script>

<div class="person-container">
    {#if card}
        <div>
            <button
                in:fly="{{ y: 80, opacity: 0, duration: 750 }}"
                on:click="{() => {
                    dispatch('unselect', {})
                    card = null
                }}"
                class="details"
                ><img src="/media/arrow-left-thin.svg" alt="arrow" /> <span>Zurück zur Liste</span></button
            >
            <PersonDetails subPointId="{card[1]}" person="{card[0]}" />
        </div>
    {:else}
        <div>
            {#each subPoint.person as person, i (i)}
                <button
                    id="trowNr-{rowI}-tsubPointNr-{i}"
                    on:click="{() => {
                        card = [person, subPoint.id]
                        dispatch('select', {
                            person: person,
                        })
                    }}"
                >
                    <PersonCard person="{person}" subPointId="{subPoint.id}" i="{i}" />
                </button>
            {/each}
        </div>
    {/if}
</div>

<style lang="less">
    @import "../../assets/css/variables.less";
    .details {
        display: flex;
        align-items: center;
        padding-bottom: 21px;
    }
    .person-container {
        transition: all 600ms;
        @media @mobile {
            padding: 0px 0px 20px 10px;
        }
        @media @tablet {
            padding: 0px 0px 20px 40px;
        }
    }
</style>
